module.exports = __webpack_public_path__ + "static/media/cards.f23eb9a3.svg";